interface TeamInvitationTemplateProps {
  inviteeEmail: string;
  inviterName?: string;
  signupUrl: string;
}

export const TeamInvitationTemplate = ({ inviteeEmail, inviterName, signupUrl }: TeamInvitationTemplateProps) => {
  return `
    <div style="font-family: 'Poppins', Arial, sans-serif; max-width: 600px; margin: 0 auto; background-color: #F9FAFC; padding: 20px;">
      <div style="background-color: #FFFFFF; border-radius: 12px; padding: 30px; box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);">
        <div style="text-align: center; margin-bottom: 30px;">
          <img src="https://s3.ap-southeast-2.amazonaws.com/fs.enterprisedna.co/logos/helpgenie.png" alt="Help Genie" style="height: 60px; margin-bottom: 20px;" />
          <h1 style="color: #4E9CFF; margin: 0; font-size: 28px; font-weight: 600;">You're Invited!</h1>
        </div>
        
        <div style="text-align: center; margin-bottom: 30px;">
          <h2 style="color: #28406F; margin: 0 0 15px 0; font-size: 22px; font-weight: 500;">Join Our Team on Help Genie</h2>
          <p style="color: #6B7280; margin: 0; font-size: 16px; line-height: 1.6;">
            Hello! ${inviterName ? `<strong>${inviterName}</strong> has` : "You have been"} invited you to join our team on Help Genie.
          </p>
        </div>
        
        <div style="background-color: #F9FAFC; padding: 25px; border-radius: 8px; border-left: 4px solid #4E9CFF; margin-bottom: 30px;">
          <p style="color: #1A1A1A; margin: 0 0 20px 0; font-size: 16px; line-height: 1.6;">
            Help Genie is a powerful platform that helps teams manage customer interactions and extract valuable insights from conversations. As a team member, you'll have access to:
          </p>
          <ul style="margin: 0; padding-left: 20px; color: #1A1A1A;">
            <li style="margin-bottom: 8px;">Advanced conversation analytics</li>
            <li style="margin-bottom: 8px;">Real-time collaboration tools</li>
            <li style="margin-bottom: 8px;">Automated insights and reporting</li>
            <li style="margin-bottom: 8px;">Team performance metrics</li>
          </ul>
        </div>
        
        <div style="text-align: center; margin-bottom: 30px;">
          <table role="presentation" border="0" cellpadding="0" cellspacing="0" align="center" style="margin: 0 auto;">
            <tr>
              <td align="center" bgcolor="#3B82F6" style="border-radius: 8px; background-color: #3B82F6; box-shadow: 0 4px 12px rgba(78, 156, 255, 0.3);">
                <a href="${signupUrl}" style="display: inline-block; color: #ffffff; padding: 16px 32px; text-decoration: none; font-weight: 600; font-size: 16px; font-family: 'Poppins', Arial, sans-serif;">
                  Accept Invitation
                </a>
              </td>
            </tr>
          </table>
          <p style="color: #9CA3AF; font-size: 12px; margin: 12px 0 0 0;">
            Button not showing? Copy this link: <a href="${signupUrl}" style="color: #4E9CFF;">${signupUrl}</a>
          </p>
        </div>

        <div style="background-color: #FFF9E6; padding: 20px; border-radius: 8px; border-left: 4px solid #FFBB33; margin-bottom: 25px;">
          <p style="color: #1A1A1A; margin: 0; font-size: 14px; line-height: 1.5;">
            <strong>Note:</strong> This invitation was sent to <strong>${inviteeEmail}</strong>. If you weren't expecting this invitation or have any questions, please contact our support team.
          </p>
        </div>
        
        <div style="text-align: center; padding-top: 20px; border-top: 2px solid #E5EAF0;">
          <p style="color: #7C8B9C; margin: 0 0 10px 0; font-size: 14px;">
            Need help? Contact our support team
          </p>
          <p style="color: #7C8B9C; margin: 0; font-size: 14px;">
            Best regards,<br>The Help Genie Team
          </p>
        </div>
      </div>
    </div>
  `;
};
